// @ts-nocheck
// eslint-disable-next-line camelcase
import { unstable_createMuiStrictModeTheme } from '@material-ui/core/styles';

export default unstable_createMuiStrictModeTheme({
  palette: {
    type: 'dark',
    primary: {
      main: '#d24e4b',
    },
    secondary: {
      main: '#d24e4b',
    },
    text: {
      primary: 'rgba(255, 255, 255, 0.7)',
    },
    overlay: '#3b3b3b',
    divider: '#595959',
  },
  overrides: {
    MuiIconButton: {
      root: {
        color: 'inherit',
      },
    },
    MuiBreadcrumbs: {
      root: {
        backgroundColor: '#424242',
      },
    },
    MuiListItemIcon: {
      root: {
        color: 'inherit',
      },
    },
    MuiTextField: {
      root: {
        '& label.Mui-focused': {
          color: 'rgba(255, 255, 255, 0.54)',
        },
        '& label.Mui-error': {
          color: '#f44336',
        },
      },
    },
    MuiOutlinedInput: {
      root: {
        '&.Mui-focused $notchedOutline': {
          borderColor: 'rgba(255, 255, 255, 0.54)',
        },
        '&.Mui-error $notchedOutline': {
          borderColor: '#f44336',
        },
        '&:hover $notchedOutline': {
          borderColor: 'rgba(255, 255, 255, 0.54)',
        },
        '& $notchedOutline': {
          borderColor: 'rgba(255, 255, 255, 0.32)',
        },
      },
    },
  },
});
